module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQueryNotifications),
      expression: "searchQueryNotifications"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "search",
      "placeholder": "Search Notifications",
      "id": "example-search-input"
    },
    domProps: {
      "value": (_vm.searchQueryNotifications)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQueryNotifications = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('data-table', {
    attrs: {
      "data": _vm.notifications,
      "columns": _vm.gridColumnsNotifications,
      "filter-key": _vm.searchQueryNotifications
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76109852","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/AlertsNotifications/AlertsNotifications.vue
// module id = 649
// module chunks = 1